export const UMB_CULTURE_REPOSITORY_ALIAS = 'Umb.Repository.Culture';
